// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"84b7986c","36":"494bcfc0","44":"b8625171","61":"81bb0127","94":"6b4a7316","159":"7896fc0e","246":"beb1b66c","261":"fcef79ff","294":"6d790176","356":"b3f1a19a","363":"2c7c24b2","576":"0ee46b30","873":"2d8b644f"}[chunkId] + ".chunk.js";
};